import React, { useContext } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ApplicantProfileTabs from "../Contents/ApplicantProfile/ApplicantProfileTabs";
import { Button, IconButton, TextField } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { useState } from "react";
import { ContextData } from "../../../context/Context";
import { Getrequest, Putrequest } from "../../../context/AxiosRequest";
import { toast } from "react-toastify";

function SelectionProcess() {


  const [searchText, setSearchText] = useState("");
  const {accesstoken,GlobalLoader,setGlobalLoader,Allow} = useContext(ContextData)
  const [ApplicantData,setApplicantData] = React.useState(null)
  const [GetToken,setGetToken] = React.useState()
  const [Reload,setReload] = useState(false)
  
      const GetApplicant = (user_token)=>{
  
       setGetToken(user_token)

      }
  
      React.useEffect(()=>{
  

                    async function FetchData() {
                         const response = await Getrequest(`auth/get_applicantBio_for_qualification_type/selection`,accesstoken)
                          setApplicantData(response)
                    }
    
                   FetchData()


      },[GlobalLoader,Reload])

      

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };




   const HandleSelect = (selecttype,token)=>{
                     
                   const data = {
                    selecttype,
                    user_token : token
                   }
  
                  async function FetchData() {
                    
                      const response = await Putrequest("/auth/select_applicant",data,accesstoken)
                      toast.success(response)
                      setReload(!Reload)
  
                  }      
  
                  FetchData()
          
     }

  
  return (
    <div className="h-[92vh] p-6">

      <h1 className="font-bold text-2xl">Selection Process</h1>

      <TextField
        label="Search"
        variant="outlined"
        value={searchText}
        onChange={handleSearchChange}
        InputProps={{
          endAdornment: (
            <IconButton>
              <SearchIcon />
            </IconButton>
          ),
        }}
        fullWidth
        margin="normal"
      />
      <div className=" d-flex items-start h-[100%]  ">
        <div
          style={{ height: "100%" }}
          className="verification-aside w-1/3 bg-slate-100 overflow-auto border-r-2 border-black border-solid"
        >
          <ul className="ver-aside-ul mb-28">
            {ApplicantData !== null && ApplicantData.map((item, index) => (
              <li className={`flex justify-between whitespace-nowrap  items-center ${item.user_token === GetToken && "bg-blue-700 text-white"}`} onClick={()=> GetApplicant(item.user_token)}  key={index}>
                <span>
                <span className="pl-1 pr-1">{index + 1}.</span>
                <AccountCircleIcon /> {`${item.fname}`}
                </span>
                <span className="flex pr-2">
                  <Button onClick={()=>HandleSelect("rejected_for_award",item.user_token)} variant="contained" sx={{background:"darkred",marginRight:"4px"}} disabled={item.user_token !== GetToken }>Rejected</Button>
                  <Button onClick={()=>HandleSelect("selected_for_award",item.user_token)} variant="contained" disabled={item.user_token !== GetToken }>selected</Button>
                </span>
                
              </li> 
            ))}
          </ul> 
        </div>

        <div style={{ height: "100%", width:"100%" }} className="overflow-auto mb-40">
          <ApplicantProfileTabs sty="sty" usertoken={GetToken} from="verification" />
        </div>
      </div>
    </div>
  );
}

export default SelectionProcess;
